import type { PaginatedArrayResponse } from '@looming-tech/avani-infra-v2-shared';
import type {
  ClientEstateReportData,
  GasCopReportData,
  ResponseVisitDashboardTapReportsParams,
  VisitAmsPartReportData,
  VisitGlassWasherReportData,
  VisitStatus,
  VisitsClientReportData,
  VisitsGeneralReportData,
  VisitTapReportData
} from '../types';
import { apiGet } from './api-client';
import { BasicPaginationParams, type PaginationParams } from './params';

const apiName = 'avaniV2HttpApi';
const path = 'utils/reports';

export const getProDashboardTapsReportsData = async (
  visitId: string,
  from: string | null,
  to: string | null
): Promise<ResponseVisitDashboardTapReportsParams> => {
  return apiGet(apiName, `${path}/visit-taps/${visitId}`, { from, to });
};

export const getVisitsGeneralReportData = async (
  from: string,
  to: string,
  status: VisitStatus,
  paginationParams: BasicPaginationParams = new BasicPaginationParams(),
  isExport?: boolean
): Promise<PaginatedArrayResponse<VisitsGeneralReportData>> => {
  return apiGet(apiName, `${path}/visits/general`, {
    from,
    to,
    status,
    ...paginationParams,
    ...(isExport && { isExport })
  });
};

export const getClientEstateReportData = async (
  clientId: string,
  paginationParams: BasicPaginationParams = new BasicPaginationParams(),
  isExport?: boolean
): Promise<PaginatedArrayResponse<ClientEstateReportData>> => {
  return apiGet(apiName, `${path}/client/estate/${clientId}`, {
    ...paginationParams,
    ...(isExport && { isExport })
  });
};

export const getVisitsClientReportData = async (
  from: string,
  to: string,
  clientId: string,
  status: VisitStatus,
  paginationParams: BasicPaginationParams = new BasicPaginationParams(),
  isExport?: boolean
): Promise<PaginatedArrayResponse<VisitsClientReportData>> => {
  return apiGet(apiName, `${path}/visits/client/${clientId}`, {
    from,
    to,
    status,
    ...paginationParams,
    ...(isExport && { isExport })
  });
};

export const getAmsPartsUsedReportData = async (
  from: string,
  to: string,
  brewerId: string,
  paginationParams: BasicPaginationParams = new BasicPaginationParams(),
  isExport?: boolean
): Promise<PaginatedArrayResponse<VisitAmsPartReportData>> => {
  return apiGet(apiName, `${path}/visit-ams-parts/${brewerId}`, {
    from,
    to,
    ...paginationParams,
    ...(isExport && { isExport })
  });
};

export const getVisitTapsReport = async (
  from: string,
  to: string,
  clientId: string,
  venueIds?: string,
  paginationParams: BasicPaginationParams = new BasicPaginationParams(),
  isExport?: boolean
): Promise<PaginatedArrayResponse<VisitTapReportData>> => {
  return apiGet(apiName, `${path}/visit-taps`, {
    from,
    to,
    clientId,
    ...(venueIds && { venueIds }),
    ...paginationParams,
    ...(isExport && { isExport })
  });
};

export const getGasCopReportData = async (
  from?: string,
  to?: string,
  clientId?: string,
  venueIds?: string,
  paginationParams: BasicPaginationParams | PaginationParams = new BasicPaginationParams(),
  isExport?: boolean
): Promise<PaginatedArrayResponse<GasCopReportData>> => {
  return apiGet(apiName, `${path}/gas-cop`, {
    ...(from && { from }),
    ...(to && { to }),
    ...(clientId && { clientId }),
    ...(venueIds && { venueIds }),
    ...paginationParams,
    ...(isExport && { isExport })
  });
};

export const getVisitWashersReport = async (
  from: string,
  to: string,
  clientId?: string,
  venueIds?: string,
  paginationParams: BasicPaginationParams = new BasicPaginationParams(),
  isExport?: boolean
): Promise<PaginatedArrayResponse<VisitGlassWasherReportData>> => {
  return apiGet(apiName, `${path}/visit-washers`, {
    from,
    to,
    ...(clientId && { clientId }),
    ...(venueIds && { venueIds }),
    ...paginationParams,
    ...(isExport && { isExport })
  });
};
